module.exports = __webpack_public_path__ + "img/plexus_poster.415ffacd.jpg";